import { z } from 'zod';

export const Inspection_itemsScalarFieldEnumSchema = z.enum(['id','inspections_types_items_id','title','status','comment','type','order','inspection_section_id','created_at','updated_at']);

export default Inspection_itemsScalarFieldEnumSchema;
